import CustomElement from '~utilities/custom-element';

class ShowMore extends CustomElement {
    constructor() {
        super();
        console.log('show more')
    }


    callback() {
        super.callback();

        const scrollEl = window;
        const showMore = document.getElementsByClassName(['c-showmore'])[0];

        // console.log(scrollEl);

        scrollEl.addEventListener('scroll', e => {
            if (e.currentTarget.scrollY > 1) {
                showMore.classList.add('hidden');
            } else {
                showMore.classList.remove('hidden');
            }

        }, { passive: true });


        this.element.querySelector('[js-show-more]').addEventListener('click', e => {
            console.log('clicked', scrollEl)
            scrollEl.scrollTop = 10000;
            window.scrollTo(0, 200000);
        });
    }

}

export default ShowMore;
